import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5db9c557"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Účastnící")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Účastnící")
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "ion-margin ion-padding ion-text-center" }

import { IonCard, IonContent, IonHeader, IonItem, IonLabel, IonList, IonListHeader, IonPage, IonNote, IonTitle, IonToolbar } from '@ionic/vue'
import AttendeeItem from '@/components/AttendeeItem.vue'

import { computed } from 'vue'
import { useEventStore, EventCompany, EventAttendee } from '@/store/event'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventAttendeesTab',
  setup(__props) {

const $store = useEventStore()

const attendeesSorted = computed(() => [...$store.attendees].sort((a, b) => a.name.localeCompare(b.name)))

const attendeesGrouped = computed<{
  title?: string,
  company?: EventCompany,
  attendees: EventAttendee[]
}[]>(() => [
  ...$store.companies.map(company => ({
    company,
    attendees: attendeesSorted.value.filter(attendee => attendee.companyId === company.__id)
  })),
  {
    title: 'Ostatní',
    attendees: attendeesSorted.value.filter(attendee => !attendee.companyId)
  }
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), {
        collapse: "fade",
        translucent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { fullscreen: "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonHeader), { collapse: "condense" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonToolbar), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonTitle), { size: "large" }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(attendeesGrouped), (group) => {
            return (_openBlock(), _createBlock(_unref(IonList), {
              key: group.company?.__id ?? group.title
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonListHeader), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        (group.company?.logoUrl)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: group.company.logoUrl,
                              class: "category-logo"
                            }, null, 8, _hoisted_3))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(group.company?.name ?? group.title), 1)
                            ], 64))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.attendees, (item) => {
                  return (_openBlock(), _createBlock(AttendeeItem, {
                    key: item.__id,
                    item: item
                  }, null, 8, ["item"]))
                }), 128)),
                _createVNode(_unref(IonCard), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonList), { lines: "full" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.company?.jobs, (job) => {
                          return (_openBlock(), _createBlock(_unref(IonItem), {
                            key: job,
                            href: job.linkUrl,
                            target: "_blank"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonLabel), null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(job.title), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["href"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(IonNote), null, {
              default: _withCtx(() => [
                _createTextVNode(" Přítomno " + _toDisplayString(_unref($store).attendees.filter(item => item.present).length) + " z celkem " + _toDisplayString(_unref($store).attendees.length) + " účastníků. ", 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})